import Cookies from 'universal-cookie';
import { COOKIE_FUNCTIONAL } from 'constants/cookies';

const cookies = new Cookies();
export const getFunctionalCookieState = () => cookies.get(COOKIE_FUNCTIONAL) === '1';
